import { getChartPalette } from "../theme";
import type { ChartContext } from "./context";

export function buildPolarAreaOption(
  context: ChartContext,
): Record<string, unknown> {
  const { data, isDark, translateNode, unitText, ct, base } = context;
  const ds = data.datasets[0];
  if (!ds) return base;
  const values = ds.values as number[];
  const colors = getChartPalette(isDark, data.labels.length);
  return {
    ...base,
    tooltip: {
      trigger: "item",
      backgroundColor: ct.bgElevated,
      borderColor: ct.border,
      formatter: (p: { name: string; value: number; percent: number }) =>
        `${translateNode(p.name)}: ${unitText(p.value)} (${p.percent}%)`,
    },
    series: [
      {
        type: "pie",
        roseType: "area",
        data: data.labels.map((name, i) => ({
          name,
          value: values[i] ?? 0,
          itemStyle: { color: colors[i % colors.length] },
        })),
        label: {
          show: true,
          formatter: (p: { name: string; percent: number }) =>
            `${translateNode(p.name)}: ${p.percent}%`,
          color: ct.color,
          textBorderColor: "transparent",
          textBorderWidth: 0,
        },
        emphasis: {
          label: {
            show: true,
            color: ct.color,
            textBorderColor: "transparent",
            textBorderWidth: 0,
            fontWeight: "bold",
          },
        },
      },
    ],
  };
}
